import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from '../services/api-request.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  //ngModels
  homeBackground: any;
  homeStyles: any = [];
  transactionName: any;
  transactionPhone: any;
  transactionEmail: any;
  transactionLastName: any;
  transactionOpenField: any;
  transactionContactShcedule: any;
  merchant: any;
  contactOptions: any = ['Llamame ahora','Llamame mañana entre las 9 y las 15 hs','Llamame mañana entres las 15 hs y las 21 hs','Llamame en 48 horas'];
  tcUrl: string;
  ppUrl: string;

  // Footer social networks
  socialNetworkFooter: any;

  hasFacebookNetwork: boolean = false;
  urlFacebookNetwork: string;

  hasTwitterNetwork: boolean = false
  urlTwitterNetwork: string;

  hasInstagramNetwork: boolean = false
  urlInstagramNetwork: string;

  hasYoutubeNetwork: boolean = false
  urlYoutubeNetwork: string;

  hasGooglePNetwork: boolean = false
  urlGooglePNetwork: string;

  hasPinterestNetwork: boolean = false
  urlPinterestNetwork: string;

  hasLinkedinNetwork: boolean = false
  urlLinkedinNetwork: string;

  hasHomeNetwork: boolean = false;
  urlHomeNetwork: string;

  // Form group
  checkoutForm: FormGroup;

  //Regex validation
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  // Errors errorExpMonth
  errorEmail: boolean = false;
  errorName: boolean = false;
  errorLastName: boolean = false;
  errorPhone: boolean = false;
  errorEmpty: boolean = false;
  invalidMail: boolean = false;
  invalidPhone: boolean = false;

  // Loader transaction
  showLoaderTransaction: boolean = false;

  modalConfirm: boolean = false;
  modalError: boolean = false;

  constructor(private apiRequestsService: ApiRequestService,) { }

  ngOnInit() {
    let _ = this;
    _.whereIam();
    _.checkoutValidationForm();
    _.tcUrl = `https://alwayson.recaudia.com/${_.merchant}/terminos-y-condiciones`
    _.ppUrl = `https://alwayson.recaudia.com/${_.merchant}/aviso-de-privacidad`
  }

  whereIam(){
      let _ = this;

      let getUrl: any = location.href;
      getUrl = getUrl.split('/');
      _.merchant = getUrl[3];
      if(_.merchant == ''){
        location.href = 'https://alwayson.recaudia.com';
        return
      }
      _.apiRequestsService.getDesign(_.merchant).subscribe(data => {
        console.log(data);
        _.homeStyles = data['results']['design'];
        _.homeBackground = data['results']['design']['background']['background'];
        _.socialNetworkFooter = data['results']['design']['footer'].social_networks;
        document.title = data['results']['design'].merchant_name;
        _.howSocialNetwork();
      },
      err => {
        location.href = "/"
      }
    );
  }

  upPlaceholder(placeholderId, inputId){
    let placeholderElement = document.getElementById(placeholderId);
    let inputPlaceholderElement = document.getElementById(inputId);
    placeholderElement.classList.add('upPlaceholder');
    setTimeout(() => {
      inputPlaceholderElement.focus();
    }, 100)
    return
  }

  downPlaceholder(placeholderId, inputId){
    let inputPlaceholderElement = (<HTMLInputElement> document.getElementById(inputId));
    let placeholderElement = document.getElementById(placeholderId);

    if(inputPlaceholderElement.value == ''){
      placeholderElement.classList.remove('upPlaceholder');
      return
    }
  }

  checkoutValidationForm(){
    let _ = this;
    _.checkoutForm = new FormGroup({
      emailHomeInput: new FormControl('emailHomeInput', Validators.required),
      nameHomeInput: new FormControl('nameHomeInput', Validators.required),
      lastNameHomeInput: new FormControl('lastNameHomeInput', Validators.required),
      phoneHomeInput: new FormControl('phoneHomeInput', Validators.required),
      openFieldHomeInput: new FormControl('openFieldHomeInput', Validators.required),
      contactScheduleHomeSelect: new FormControl('contactScheduleHomeSelect', Validators.required)
    });
  }

  howSocialNetwork(){
    let _ = this;
    for(var i = 0; i < _.socialNetworkFooter.length; i++){
      if(_.socialNetworkFooter[i].name == 'facebook'){
        _.hasFacebookNetwork = true;
        _.urlFacebookNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'twitter'){
        _.hasTwitterNetwork = true;
        _.urlTwitterNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'instagram'){
        _.hasInstagramNetwork = true;
        _.urlInstagramNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'youtube'){
        _.hasYoutubeNetwork = true;
        _.urlYoutubeNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'google_plus'){
        _.hasGooglePNetwork = true;
        _.urlGooglePNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'pinterest'){
        _.hasPinterestNetwork = true;
        _.urlPinterestNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'linkedin'){
        _.hasLinkedinNetwork = true;
        _.urlLinkedinNetwork = _.socialNetworkFooter[i].url;
      }

      if(_.socialNetworkFooter[i].name == 'home'){
        _.hasHomeNetwork = true;
        _.urlHomeNetwork = _.socialNetworkFooter[i].url;
      }
    }
  }

  justTenDigits(){
    let _ = this;
    if(_.transactionPhone == undefined || _.transactionPhone == null){
      return;
    }

    if(_.transactionPhone.toString().length > 10){
     _.transactionPhone = _.transactionPhone.toString().substr(0, 10)
    }
  }

  emailValidation(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  numberValidation(item){
    let re = /^\d+$/;
    return re.test(item);
  }

  validatePhoneNumber(phone){
      // var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      // return re.test(phone);
      if(phone.toString().length < 10 || phone.toString().length > 15){
      return false
    } else {
      let re = /^[\d ()+]+$/;
      return re.test(phone);
    }
  }

  validateStepOne(){
    let _ = this;
    let circleBtn2 = document.getElementById('cicleStep2Active');

    let invoiceData = {email: _.transactionEmail}

    if( _.transactionEmail == '' || _.transactionEmail == undefined){
      _.errorEmail = true;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if(!_.emailValidation(_.transactionEmail)){
      _.errorEmpty = false;
      _.errorEmail = true;
      _.invalidMail = true;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if(_.transactionName == '' || _.transactionName == undefined){
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = true;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if(_.transactionLastName == '' || _.transactionLastName == undefined){
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = true;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if(_.transactionPhone == '' || _.transactionPhone == undefined){
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = true;
      _.invalidPhone = false;
      return false;
    }
    if(!_.validatePhoneNumber(_.transactionPhone)){
      _.errorEmpty = false;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = true;
      _.invalidPhone = true;
      return false;
    }
    if(_.transactionContactShcedule == '' || _.transactionContactShcedule == undefined){
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    _.errorEmpty = false;
    _.errorEmail = false;
    _.invalidMail = false;
    _.errorName = false;
    _.errorLastName = false;
    _.errorPhone = false;
    _.invalidPhone = false;
    let personData = {
      "donor":{
        "email": _.transactionEmail,
        "name": _.transactionName,
        "lastname": _.transactionLastName,
        "phone": _.transactionPhone.toString(),
        "profession": _.transactionOpenField,
        "schedule": _.transactionContactShcedule
      },
      "merchant": _.merchant
    }
    _.showLoaderTransaction = true;
    _.apiRequestsService.sendPersonData(personData).subscribe(data => {
      _.modalConfirm = true;
      _.showLoaderTransaction = false;
    },
    error =>{
      _.modalError = true;
      _.showLoaderTransaction = false;
    })
  }

  clearData(){
    let _ = this;
    window.location.reload();
  }
}
